import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { UUIDGenerator } from 'src/app/utils/uuid-generator';

@Component({
  selector: 'shared-checkbox-lovers',
  templateUrl: './checkbox-lovers.component.html',
  styleUrls: ['./checkbox-lovers.component.scss'],
})
export class CheckboxLoversComponent implements OnInit {
  @Input() controlName: string = '';
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() disabled: boolean = false;
  @Input() ngModel: boolean = false;
  @Input() labelPrimaria: boolean = false;
  @Input() labelAceite: boolean = false;
  @Input() darkMode: boolean = false;
  @Input() labelBranca: boolean = false;

  @Output() public onChange: EventEmitter<null> = new EventEmitter();
  @Output() public onTermosClick: EventEmitter<null> = new EventEmitter();
  @Output() public onRegulamentosClick: EventEmitter<null> = new EventEmitter();

  public formGroup!: FormGroup;
  public idCampo: string = '';

  constructor(
    private formGroupDirective: FormGroupDirective,
    private UUID: UUIDGenerator
  ) {}

  ngOnInit(): void {
    this.idCampo = this.UUID.gerarUUID();
    this.formGroup = this.formGroupDirective.form;
  }

  public onInputChange() {
    this.onChange.emit();
  }

  public onLinkClick(event: any, text: string) {
    event.preventDefault();
    event.stopPropagation();
    if (text == 'Termos') {
      this.onTermosClick.emit();
    }
    if (text == 'Regulamentos') {
      this.onRegulamentosClick.emit();
    }
  }
}
